import React, { useState } from "react";
import { createAllMissingInvoices } from "API/swesum";
import { usePopupNotificationContext } from "Context/NotificationPopup";

import Textfield from "Components/UI/Form/Textfield";

import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

export default function CreateAllMissingInvoices() {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const { openError } = usePopupNotificationContext();

  const createMissingInvoices = async () => {
    try {
      setLoading(true);
      const res = await createAllMissingInvoices();
      setMessage(res.data.Message);
    } catch (error) {
      console.error(error);
      openError("Något gick fel");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h6" sx={{ pt: 4, pb: 6 }}>
        Skapa poster i tabellerna fakturor och klienter från tabellen
        fakturabuntar
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield disabled label="Meddelande" value={message} />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <LoadingButton
          loading={loading}
          onClick={createMissingInvoices}
          variant="contained"
        >
          Starta
        </LoadingButton>
      </Grid>
    </>
  );
}
